if $("#pushNotificationModal").length > 0
  $('.notifications-tag-custom-box').click (event) ->
    class_names = $(this).attr('class')
    tag = '#' + $(this).parent().attr('tags_id').toString()
    if class_names.indexOf('user-available-tag') != -1
      $(this).removeClass 'user-available-tag'
      $(this).addClass 'user-selected-tag'
      $(this).find('.tag-close').text 'x'
      names = $(event.target).attr('class')
      if names.indexOf('country') != -1
        $(this).find('.tag-label').removeClass 'tag-label-country'
        $(this).find('.tag-label').addClass 'tag-label-country-full'
      else if names.indexOf('office') != -1
        $(this).find('.tag-label').removeClass 'tag-label-office'
        $(this).find('.tag-label').addClass 'tag-label-office-full'
      else if names.indexOf('role') != -1
        $(this).find('.tag-label').removeClass 'tag-label-role'
        $(this).find('.tag-label').addClass 'tag-label-role-full'
      $(tag).val $(tag).val().concat(',' + $(this).find('.tag-label').text())
    else if class_names.indexOf('user-selected-tag') != -1
      $(this).removeClass 'user-selected-tag'
      $(this).addClass 'user-available-tag'
      $(this).find('.tag-close').text '+'
      names = $(event.target).attr('class')
      if names.indexOf('country') != -1
        $(this).find('.tag-label').addClass 'tag-label-country'
        $(this).find('.tag-label').removeClass 'tag-label-country-full'
      else if names.indexOf('office') != -1
        $(this).find('.tag-label').addClass 'tag-label-office'
        $(this).find('.tag-label').removeClass 'tag-label-office-full'
      else if names.indexOf('role') != -1
        $(this).find('.tag-label').addClass 'tag-label-role'
        $(this).find('.tag-label').removeClass 'tag-label-role-full'
      tag_used = $(tag).val().split(',')
      match_index = tag_used.indexOf($(this).find('.tag-label').text())
      if match_index != -1
        tag_used.splice match_index, 1
        $(tag).val tag_used.join(',')
    return
    
  $('.hide-modal').click (event) ->
    $(this).parents('.modal').hide()
    return

  push_notification_triggers = {
    "story_unlocked" : "Story Unlocked",
    "chapter_unlocked" : "Chapter Unlocked"
  }

  view_inform_notification_callback = ->
    regex = new RegExp('=>', 'g')
    message = JSON.parse($(this).data('inform_message').replace(regex, ':'))['text']
    trigger_time = $(this).data('inform_scheduled_time')
    $("#informPushNotificationModal").find("#inform-trigger-time").html(trigger_time)
    if typeof message == 'object'
      language_ids = Object.keys(message)
      for l_id in language_ids
        p = $("<p></p>")
        p.css(
          'font-size': '18px'
          'word-wrap': 'break-word'
          'word-break': 'break-all'
        )
        p.text(message[l_id.toString()])
        $("#informPushNotificationModal").find("#inform_message_#{l_id}").html(p)
    else
      $("div[id^='inform_message_']").each ->
        p = $("<p></p>")
        p.css(
          'font-size': '18px'
          'word-wrap': 'break-word'
          'word-break': 'break-all'
        )
        p.text(message)
        $(this).html(p)

    $('#informPushNotificationModal').find('#filters-link').attr("href", $(this).data('inform_filters_link'))
    $("#informPushNotificationModal").openModal
      complete: ->
        $("#informPushNotificationModal").find("#inform_message").empty()
    $("#informPushNotificationModal").find("#inform_message_close").click (event) ->
      event.preventDefault()
      $("#informPushNotificationModal").closeModal()
  $("[data-inform_message]").click(view_inform_notification_callback)

  view_scheduled_notification_callback = ->
    regex = new RegExp('=>', 'g')
    message = JSON.parse($(this).data('scheduled_message').replace(regex, ':'))['text']
    runtime = JSON.parse($(this).data('scheduled_message').replace(regex, ':'))['runtime']
    $("#scheduledPushNotificationModal").find("#runtime-val").html(runtime)
    if typeof message == 'object'
      language_ids = Object.keys(message)
      for l_id in language_ids
        p = $("<p></p>")
        p.css(
          'font-size': '18px'
          'word-wrap': 'break-word'
          'word-break': 'break-all'
        )
        p.text(message[l_id.toString()])
        $("#scheduledPushNotificationModal").find("#scheduled_message_#{l_id}").html(p)
    else
      $("div[id^='scheduled_message_']").each ->
        p = $("<p></p>")
        p.css(
          'font-size': '18px'
          'word-wrap': 'break-word'
          'word-break': 'break-all'
        )
        p.text(message)
        $(this).html(p)

    $('#scheduledPushNotificationModal').find('#filters-link').attr("href", $(this).data('scheduled_filters_link'))
    $("#scheduledPushNotificationModal").openModal
      complete: ->
        $("#scheduledPushNotificationModal").find("#scheduled_message").empty()
    $("#scheduledPushNotificationModal").find("#scheduled_message_close").click (event) ->
      event.preventDefault()
      $("#scheduledPushNotificationModal").closeModal()
  $("[data-scheduled_message]").click(view_scheduled_notification_callback)

  $("#push_notification_trigger").change ->
    $("#send_course_scheduled_push_notification").unbind()
    $("#send_course_inform_push_notification").unbind()
    $("[id$='_notification_form']").hide()
    $(".trigger-filter-users").hide()
    unless !!$(this).val()
    else
      $("[id='#{$(this).val()}_notification_form']").css("display","block")
      $("[id='#{$(this).val()}_trigger_filter_users']").css("display","block")
      $("#send_course_inform_push_notification").click ->
        messages = {}
        correct_message = false
        index = $("[id^='course_inform_notification_message_']").length
        $("textarea[id^='course_inform_notification_message_']").each ->
          id_parts = $(this).attr('id').split('_')
          language_id = id_parts[id_parts.length - 1]
          messages[language_id] ||= {}
          if !!$(this).val()
            messages[language_id] = $(this).val()
            correct_message = true
        correct_content_length = true        
        if Object.keys(messages).length > 0
          for message in messages
            if message.length > 65
              correct_content_length = false
              break
          if correct_content_length && correct_message
            button = $(this)
            button.css("pointer-events","none")
            course_id = button.siblings("#push_notification_course_id").val()
            inform_date = $("#inform_date").val()
            inform_time = $("#inform_time").val()
            inform_groups = $.map($('input[name=\'inform_groups\']:checked'), (element, index) ->
              parseInt $(element).val()
            ).join ','
            inform_roles = $.map($('input[name=\'inform_roles\']:checked'), (element, index) ->
              parseInt $(element).val()
            ).join ','

            inform_country_tags = $('#inform_country_tags').val()
            inform_office_tags = $('#inform_office_tags').val()
            inform_role_tags = $('#inform_role_tags').val()

            $.post("/courses/#{course_id}/send_push_notification.json",{message: messages, inform_groups: inform_groups, inform_roles: inform_roles, inform_country_tags: inform_country_tags, inform_office_tags: inform_office_tags, inform_role_tags: inform_role_tags, inform_date: inform_date, inform_time: inform_time, notification_type: "inform", authenticity_token: $("meta[name=\"csrf-token\"]").attr("content")}).done(
              (data) ->
                $("#inform_notification_form #push_notification_success").css("color","green")
                button.css("pointer-events","all")
                if $('#notifications_course_form').length > 0
                  if data && data.row_html
                    row = $(data.row_html)
                    $("#course_push_notifications_table").find("tbody").append(row)
                    row.find("[data-inform_message]").click(view_inform_notification_callback)
                    row.find(".remove-course-schedule-notification").click(remove_schedule_notification_callback)
                  $("#inform_notification_form #push_notification_success").text("Notification sent successfully.")
                  $("#pushNotificationModal").closeModal()
                  setTimeout ->
                    $("#inform_notification_form #push_notification_success").text('')
                  , 3000
                else
                  window.location.reload()
            ).fail(
              (error) ->
                $("#inform_notification_form #push_notification_success").css("color","red")
                $("#inform_notification_form #push_notification_success").text("Unable to send notification to course users.")
                button.css("pointer-events","all")
                setTimeout ->
                  $("#inform_notification_form #push_notification_success").text('')
                ,2000
            )
          else
            $("#inform_notification_form #push_notification_success").css("color","red")
            if correct_message
              $("#inform_notification_form #push_notification_success").text("Message cannot be longer than 65 characters in length.")
            else
              $("#inform_notification_form #push_notification_success").text("Message cannot be empty.")
            setTimeout ->
              $("#inform_notification_form #push_notification_success").text('')
            ,2000
      $("#send_course_scheduled_push_notification").click ->
        messages = {}
        correct_message = false
        index = $("[id^='course_scheduled_notification_message_']").length
        $("textarea[id^='course_scheduled_notification_message_']").each ->
          id_parts = $(this).attr('id').split('_')
          language_id = id_parts[id_parts.length - 1]
          messages[language_id] ||= {}
          if !!$(this).val()
            messages[language_id] = $(this).val()
            correct_message = true
        correct_content_length = true        
        if Object.keys(messages).length > 0
          for message in messages
            if message.length > 65
              correct_content_length = false
              break
          if correct_content_length && correct_message
            button = $(this)
            button.css("pointer-events","none")
            course_id = button.siblings("#push_notification_course_id").val()
            runtime = $("#runtime").val()
            notify_at = $("#notify_at").val()
            scheduled_groups = $.map($('input[name=\'scheduled_groups\']:checked'), (element, index) ->
              parseInt $(element).val()
            ).join ','
            scheduled_roles = $.map($('input[name=\'scheduled_roles\']:checked'), (element, index) ->
              parseInt $(element).val()
            ).join ','

            scheduled_country_tags = $('#scheduled_country_tags').val()
            scheduled_office_tags = $('#scheduled_office_tags').val()
            scheduled_role_tags = $('#scheduled_role_tags').val()

            $.post("/courses/#{course_id}/send_push_notification.json",{message: messages, scheduled_groups: scheduled_groups, scheduled_roles: scheduled_roles, scheduled_country_tags: scheduled_country_tags, scheduled_office_tags: scheduled_office_tags, scheduled_role_tags: scheduled_role_tags, runtime: runtime, notify_at: notify_at, notification_type: "scheduled", authenticity_token: $("meta[name=\"csrf-token\"]").attr("content")}).done(
              (data) ->
                $("#scheduled_notification_form #push_notification_success").css("color","green")
                button.css("pointer-events","all")
                if $('#notifications_course_form').length > 0
                  if data && data.row_html
                    row = $(data.row_html)
                    $("#course_push_notifications_table").find("tbody").append(row)
                    row.find("[data-scheduled_message]").click(view_scheduled_notification_callback)
                    row.find(".remove-course-schedule-notification").click(remove_schedule_notification_callback)
                  $("#scheduled_notification_form #push_notification_success").text("Notification scheduled successfully.")
                  $("#pushNotificationModal").closeModal()
                  setTimeout ->
                    $("#scheduled_notification_form #push_notification_success").text('')
                  , 3000
                else
                  window.location.reload()
            ).fail(
              (error) ->
                $("#scheduled_notification_form #push_notification_success").css("color","red")
                $("#scheduled_notification_form #push_notification_success").text("Unable to send notification to course users.")
                button.css("pointer-events","all")
                setTimeout ->
                  $("#scheduled_notification_form #push_notification_success").text('')
                ,2000
            )
          else
            $("#scheduled_notification_form #push_notification_success").css("color","red")
            if correct_message
              $("#scheduled_notification_form #push_notification_success").text("Message cannot be longer than 65 characters in length.")
            else
              $("#scheduled_notification_form #push_notification_success").text("Message cannot be empty.")
            setTimeout ->
              $("#scheduled_notification_form #push_notification_success").text('')
            ,2000

  $("[data-language-target]").click ->
    $("[data-language-target]").css("background","transparent")
    $("[data-language-target]").removeClass("selected")
    $(this).addClass("selected")
    $(this).css("background","white")
    $("div[id^='language-']").hide()
    $("##{$(this).attr('data-language-target')}").show()

  $("[data-language-target-chapter]").click ->
    $("[data-language-target-chapter]").css("background","transparent")
    $("[data-language-target-chapter]").removeClass("selected")
    $(this).addClass("selected")
    $(this).css("background","white")
    $("div[id^='language-chapter-']").hide()
    $("##{$(this).attr('data-language-target-chapter')}").show()

  $("[data-language-target-inform]").click ->
    $("[data-language-target-inform]").css("background","transparent")
    $("[data-language-target-inform]").removeClass("selected")
    $(this).addClass("selected")
    $(this).css("background","white")
    $("div[id^='language-inform-']").hide()
    $("##{$(this).attr('data-language-target-inform')}").show()

  $("[data-language-target-inform-edit]").click ->
    $("[data-language-target-inform-edit]").css("background","transparent")
    $("[data-language-target-inform-edit]").removeClass("selected")
    $(this).addClass("selected")
    $(this).css("background","white")
    $("div[id^='inform_message_']").hide()
    $("##{$(this).attr('data-language-target-inform-edit')}").show()

  $("[data-language-target-scheduled]").click ->
    $("[data-language-target-scheduled]").css("background","transparent")
    $("[data-language-target-scheduled]").removeClass("selected")
    $(this).addClass("selected")
    $(this).css("background","white")
    $("div[id^='language-scheduled-']").hide()
    $("##{$(this).attr('data-language-target-scheduled')}").show()

  $("[data-language-target-scheduled-edit]").click ->
    $("[data-language-target-scheduled-edit]").css("background","transparent")
    $("[data-language-target-scheduled-edit]").removeClass("selected")
    $(this).addClass("selected")
    $(this).css("background","white")
    $("div[id^='scheduled_message_']").hide()
    $("##{$(this).attr('data-language-target-scheduled-edit')}").show()

  # Chosen renders its dropdown inside the modal, so the modal's own overflow clipped it and
  # scrolling the list dragged the whole popup - let the open list overlap the modal instead.
  $("#pushNotificationModal").find("select.chosen-select")
    .on("chosen:showing_dropdown", -> $("#pushNotificationModal").addClass("chosen-drop-open"))
    .on("chosen:hiding_dropdown", -> $("#pushNotificationModal").removeClass("chosen-drop-open"))

  # Every trigger's form lives in the same modal, so whichever one was last shown stays
  # visible until it is hidden again - clear them all before showing the one being opened.
  reset_notification_forms = ->
    $("#pushNotificationModal").find("[id$='_notification_form']").css("display","none")
    $("#pushNotificationModal").find(".trigger-filter-users").css("display","none")

  $("#create-course-push-notification").click ->
    $("#pushNotificationModal").attr("data-push_notification_operation","create")
    $("#pushNotificationModal").find(".select-dropdown").hide()
    $("#pushNotificationModal").find(".header").text("Create Push Notification")
    reset_notification_forms()
    $("#pushNotificationModal").find('select').val('')
    $("#pushNotificationModal").find('select').prop('disabled', false).trigger("chosen:updated")
    $("#pushNotificationModal").find('textarea').val('')
    $("#pushNotificationModal").find("[id^='push_notification_message_character_limit']").text("(0/65)")
    $("#pushNotificationModal").find("[id^='push_notification_chapter_message_character_limit']").text("(0/65)")
    $("#pushNotificationModal").openModal()

  remove_push_notification_callback = ->
    index = $(this).closest('tr').find('[data-notifiable-index]').attr('data-notifiable-index')
    $("#push_notification_fieldset_#{index}").append("<input type='hidden' name='course[push_notifications_attributes][#{index}][_destroy]' value='1' />")
    $("#push_notification_fieldset_#{index}").attr("data-destroy","1")
    $(this).closest('tr').remove()
    $("#create-course-push-notification").css("display","block")
    alert ("Notification removed, save to apply.")

  remove_push_notification_chapter_callback = ->
    index = $(this).closest('tr').find('[data-notifiable-index]').attr('data-notifiable-index')
    $("#push_notification_chapter_fieldset_#{index}").append("<input type='hidden' name='course[push_notifications_chapter_attributes][#{index}][_destroy]' value='1' />")
    $("#push_notification_chapter_fieldset_#{index}").attr("data-destroy","1")
    $(this).closest('tr').remove()
    $("#create-course-push-notification").css("display","block")
    alert ("Notification removed, save to apply.")

  edit_push_notification_callback = ->
    $("#pushNotificationModal").attr("data-push_notification_operation","edit")
    $("#pushNotificationModal").find(".select-dropdown").hide()
    $("#pushNotificationModal").find(".header").text("Edit Push Notification")
    notifiable = JSON.parse($(this).attr('data-notifiable'))
    $("#pushNotificationModal").find("#push_notification_trigger").val(notifiable.trigger)
    $("#pushNotificationModal").find(".chosen-select").prop('disabled', true).trigger("chosen:updated")
    $("#pushNotificationModal #story_unlocked_notification_form").find("textarea[id^='push_notification_message_']").each ->
      id_parts = $(this).attr('id').split('_')
      message_number = id_parts[id_parts.length - 1]
      language_id = id_parts[id_parts.length - 2]
      character_limit_span_id = "push_notification_message_character_limit_#{language_id}_#{message_number}"
      if !!notifiable.messages && !!notifiable.messages[language_id] && !!notifiable.messages[language_id][message_number]
        $(this).val(notifiable.messages[language_id][message_number])
        if $(this).val().length < 65
          $("#pushNotificationModal #story_unlocked_notification_form").find("##{character_limit_span_id}").text("(#{$(this).val().length}/65)")
          $("#pushNotificationModal #story_unlocked_notification_form").find("##{character_limit_span_id}").removeClass("red-text")
        else
          $("#pushNotificationModal #story_unlocked_notification_form").find("##{character_limit_span_id}").text("(65/65)")
          $("#pushNotificationModal #story_unlocked_notification_form").find("##{character_limit_span_id}").addClass("red-text")
      else
        $(this).val('')
        $("#pushNotificationModal #story_unlocked_notification_form").find("##{character_limit_span_id}").text("(0/65)")
        $("#pushNotificationModal #story_unlocked_notification_form").find("##{character_limit_span_id}").removeClass("red-text")

    reset_notification_forms()
    $("#pushNotificationModal #story_unlocked_notification_form").css("display", "block")
    $("#pushNotificationModal").openModal({
        complete: ->
          $("#pushNotificationModal").find('select').val('')
          $("#pushNotificationModal").find('select').prop('disabled', true).trigger("chosen:updated")
          $("#pushNotificationModal").find('textarea').val('')
          $("#pushNotificationModal").find("[id^='push_notification_message_character_limit']").text("(0/65)")
    })

  edit_push_notification_chapter_callback = ->
    $("#pushNotificationModal").attr("data-push_notification_operation","edit")
    $("#pushNotificationModal").find(".select-dropdown").hide()
    $("#pushNotificationModal").find(".header").text("Edit Push Notification")
    notifiable = JSON.parse($(this).attr('data-notifiable'))
    $("#pushNotificationModal").find("#push_notification_trigger").val(notifiable.trigger)
    $("#pushNotificationModal").find(".chosen-select").prop('disabled', true).trigger("chosen:updated")
    $("#pushNotificationModal #chapter_unlocked_notification_form").find("textarea[id^='push_notification_chapter_message_']").each ->
      id_parts = $(this).attr('id').split('_')
      message_number = id_parts[id_parts.length - 1]
      language_id = id_parts[id_parts.length - 2]
      character_limit_span_id = "push_notification_chapter_message_character_limit_#{language_id}_#{message_number}"
      if !!notifiable.messages && !!notifiable.messages[language_id] && !!notifiable.messages[language_id][message_number]
        $(this).val(notifiable.messages[language_id][message_number])
        if $(this).val().length < 65
          $("#pushNotificationModal #chapter_unlocked_notification_form").find("##{character_limit_span_id}").text("(#{$(this).val().length}/65)")
          $("#pushNotificationModal #chapter_unlocked_notification_form").find("##{character_limit_span_id}").removeClass("red-text")
        else
          $("#pushNotificationModal#chapter_unlocked_notification_form").find("##{character_limit_span_id}").text("(65/65)")
          $("#pushNotificationModal#chapter_unlocked_notification_form").find("##{character_limit_span_id}").addClass("red-text")
      else
        $(this).val('')
        $("#pushNotificationModal #chapter_unlocked_notification_form").find("##{character_limit_span_id}").text("(0/65)")
        $("#pushNotificationModal #chapter_unlocked_notification_form").find("##{character_limit_span_id}").removeClass("red-text")

    reset_notification_forms()
    $("#pushNotificationModal #chapter_unlocked_notification_form").css("display", "block")
    $("#pushNotificationModal").openModal({
        complete: ->
          $("#pushNotificationModal").find('select').val('')
          $("#pushNotificationModal").find('select').prop('disabled', true).trigger("chosen:updated")
          $("#pushNotificationModal").find('textarea').val('')
          $("#pushNotificationModal").find("[id^='push_notification_chapter_message_character_limit']").text("(0/65)")
    })

  $(".edit-course-push-notification").click(edit_push_notification_callback)
  $(".remove-course-push-notification").click(remove_push_notification_callback)

  $(".edit-course-chapter-push-notification").click(edit_push_notification_chapter_callback)
  $(".remove-course-chapter-push-notification").click(remove_push_notification_chapter_callback) 

  remove_schedule_notification_callback = (e) ->
    course_id = $(this).attr("data-course-id")
    push_notification_id = $(this).attr("data-id")
    $.post("/courses/#{course_id}/delete_push_notification.json",{push_notification_id: push_notification_id, authenticity_token: $("meta[name=\"csrf-token\"]").attr("content")}).done(
      (data) ->
        $('#old-notification-' + data["id"]).remove()
        alert ("Deleted successfully!")
    ).fail(
      (error) ->
        alert ("Unable to delete.")
    )
  $('.remove-course-schedule-notification').click(remove_schedule_notification_callback)

  $("#pushNotificationModal").find("#create_or_edit_push_notification").click ->
    errors = []
    errors.push("Please select a trigger event") unless !!$("#push_notification_trigger").val()
    if errors.length == 0
      trigger = $("#push_notification_trigger").val()
      if $("#push_notification_fields").find("[data-trigger='#{trigger}']").length == 0 || $("#push_notification_fields").find("[data-trigger='#{trigger}'][data-destroy='1']").length > 0
        index = $("[id^='push_notification_fieldset_']").length + $("[id^='push_notification_chapter_fieldset_']").length
        div = $("<div id='push_notification_fieldset_#{index}' data-trigger='#{trigger}'></div>")
        div.append("<input type='hidden' name='course[push_notifications_attributes][#{index}][trigger]' value='#{trigger}' />")
        messages = {}
        $("textarea[id^='push_notification_message_']").each ->
          id_parts = $(this).attr('id').split('_')
          message_number = id_parts[id_parts.length - 1]
          language_id = id_parts[id_parts.length - 2]
          messages[language_id] ||= {}
          if !!$(this).val()
            messages[language_id][message_number] = $(this).val()
            field = $("<input type='hidden' name='course[push_notifications_attributes][#{index}][messages][#{language_id}][#{message_number}]' />");
            field.val($(this).val());
            div.append(field);
        $("#push_notification_fields").append(div)
        json = {trigger: trigger, messages: messages}
        if $("#course_push_notifications_table").hasClass('push-notifications-table')
          tr = $("<tr class='push-notifications-table__row'></tr>")
          tr.append("<td class='push-notifications-table__td push-notification-trigger'>#{push_notification_triggers[trigger]}</td>")
          tr.append("<td class='push-notifications-table__td'></td>")
          tr.append("<td class='push-notifications-table__td'></td>")
          tr.append("<td class='push-notifications-table__td push-notifications-table__td--action'><button type='button' class='push-notifications-action-btn edit-course-push-notification' data-notifiable='#{JSON.stringify(json)}' data-notifiable-index='#{index}' aria-label='Edit notification'><svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" aria-hidden=\"true\"><path d=\"M14.0588 9.02L14.9788 9.94L5.91878 19H4.99878V18.08L14.0588 9.02ZM17.6588 3C17.4088 3 17.1488 3.1 16.9588 3.29L15.1288 5.12L18.8788 8.87L20.7088 7.04C21.0988 6.65 21.0988 6.02 20.7088 5.63L18.3688 3.29C18.1688 3.09 17.9188 3 17.6588 3ZM14.0588 6.19L2.99878 17.25V21H6.74878L17.8088 9.94L14.0588 6.19Z\" fill=\"#006AFF\"/></svg></button></td>")
          tr.append("<td class='push-notifications-table__td push-notifications-table__td--action'><button type='button' class='push-notifications-action-btn remove-course-push-notification' aria-label='Delete notification'><svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" aria-hidden=\"true\"><path d=\"M6 19C6 20.1 6.9 21 8 21H16C17.1 21 18 20.1 18 19V7H6V19ZM19 4H15.5L14.5 3H9.5L8.5 4H5V6H19V4Z\" fill=\"#E53935\"/></svg></button></td>")
        else
          tr = $("<tr></tr>")
          tr.append("<td class='push-notification-trigger'>#{push_notification_triggers[trigger]}</td>")
          tr.append("<td style='width: 220px;'></td>")
          tr.append("<td style='width: 100px;'></td>")
          tr.append("<td class='fa fa-pencil-square-o edit-course-push-notification' data-notifiable='#{JSON.stringify(json)}'  data-notifiable-index='#{index}' style='cursor: pointer'></td>")
          tr.append("<td class='fa fa-trash remove-course-push-notification' style='cursor: pointer'></td>")
        $("#course_push_notifications_table").find("tbody").append(tr)
        $(".edit-course-push-notification").click(edit_push_notification_callback)
        $("#pushNotificationModal").closeModal()
        $(".remove-course-push-notification").click(remove_push_notification_callback)
      else
        if $("#pushNotificationModal").data().push_notification_operation == "edit"
          fieldset = $("#push_notification_fields").find("[data-trigger='#{trigger}']")
          index = fieldset.attr('id').split("_").pop()
          fieldset.find("[name='course[push_notifications_attributes][#{index}][trigger]']").val(trigger)
          fieldset.find("[name^='course[push_notifications_attributes][#{index}][messages]']").remove()
          messages = {}
          $("textarea[id^='push_notification_message_']").each ->
            id_parts = $(this).attr('id').split('_')
            message_number = id_parts[id_parts.length - 1]
            language_id = id_parts[id_parts.length - 2]
            messages[language_id] ||= {}
            if !!$(this).val()
              messages[language_id][message_number] = $(this).val();
              field = $("<input type='hidden' name='course[push_notifications_attributes][#{index}][messages][#{language_id}][#{message_number}]' />");
              field.val($(this).val());
              fieldset.append(field);
          json = {trigger: trigger, messages: messages}
          $("[data-notifiable-index='#{index}']").attr("data-notifiable", JSON.stringify(json))
          $("#pushNotificationModal").closeModal()
        else
          alert("A push notification associated with the selected trigger and language already exists")
    else
      alert(errors.join("\n"))

  $("#pushNotificationModal").find("#create_or_edit_chapter_push_notification").click ->
    errors = []
    errors.push("Please select a trigger event") unless !!$("#push_notification_trigger").val()
    if errors.length == 0
      trigger = $("#push_notification_trigger").val()
      if $("#push_notification_chapter_fields").find("[data-trigger='#{trigger}']").length == 0 || $("#push_notification_chapter_fields").find("[data-trigger='#{trigger}'][data-destroy='1']").length > 0
        index = $("[id^='push_notification_chapter_fieldset_']").length + $("[id^='push_notification_fieldset_']").length
        div = $("<div id='push_notification_chapter_fieldset_#{index}' data-trigger='#{trigger}'></div>")
        div.append("<input type='hidden' name='course[push_notifications_chapter_attributes][#{index}][trigger]' value='#{trigger}' />")
        messages = {}
        $("textarea[id^='push_notification_chapter_message_']").each ->
          id_parts = $(this).attr('id').split('_')
          message_number = id_parts[id_parts.length - 1]
          language_id = id_parts[id_parts.length - 2]
          messages[language_id] ||= {}
          if !!$(this).val()
            messages[language_id][message_number] = $(this).val()
            field = $("<input type='hidden' name='course[push_notifications_chapter_attributes][#{index}][messages][#{language_id}][#{message_number}]' />");
            field.val($(this).val());
            div.append(field);
        $("#push_notification_chapter_fields").append(div)
        json = {trigger: trigger, messages: messages}
        if $("#course_push_notifications_table").hasClass('push-notifications-table')
          tr = $("<tr class='push-notifications-table__row'></tr>")
          tr.append("<td class='push-notifications-table__td push-notification-chapter-trigger'>#{push_notification_triggers[trigger]}</td>")
          tr.append("<td class='push-notifications-table__td'></td>")
          tr.append("<td class='push-notifications-table__td'></td>")
          tr.append("<td class='push-notifications-table__td push-notifications-table__td--action'><button type='button' class='push-notifications-action-btn edit-course-chapter-push-notification' data-notifiable='#{JSON.stringify(json)}' data-notifiable-index='#{index}' aria-label='Edit notification'><svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" aria-hidden=\"true\"><path d=\"M14.0588 9.02L14.9788 9.94L5.91878 19H4.99878V18.08L14.0588 9.02ZM17.6588 3C17.4088 3 17.1488 3.1 16.9588 3.29L15.1288 5.12L18.8788 8.87L20.7088 7.04C21.0988 6.65 21.0988 6.02 20.7088 5.63L18.3688 3.29C18.1688 3.09 17.9188 3 17.6588 3ZM14.0588 6.19L2.99878 17.25V21H6.74878L17.8088 9.94L14.0588 6.19Z\" fill=\"#006AFF\"/></svg></button></td>")
          tr.append("<td class='push-notifications-table__td push-notifications-table__td--action'><button type='button' class='push-notifications-action-btn remove-course-chapter-push-notification' aria-label='Delete notification'><svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" aria-hidden=\"true\"><path d=\"M6 19C6 20.1 6.9 21 8 21H16C17.1 21 18 20.1 18 19V7H6V19ZM19 4H15.5L14.5 3H9.5L8.5 4H5V6H19V4Z\" fill=\"#E53935\"/></svg></button></td>")
        else
          tr = $("<tr></tr>")
          tr.append("<td class='push-notification-chapter-trigger'>#{push_notification_triggers[trigger]}</td>")
          tr.append("<td style='width: 220px;'></td>")
          tr.append("<td style='width: 100px;'></td>")
          tr.append("<td class='fa fa-pencil-square-o edit-course-chapter-push-notification' data-notifiable='#{JSON.stringify(json)}'  data-notifiable-index='#{index}' style='cursor: pointer'></td>")
          tr.append("<td class='fa fa-trash remove-course-chapter-push-notification' style='cursor: pointer'></td>")
        $("#course_push_notifications_table").find("tbody").append(tr)
        $(".edit-course-chapter-push-notification").click(edit_push_notification_chapter_callback)
        $("#pushNotificationModal").closeModal()
        $(".remove-course-chapter-push-notification").click(remove_push_notification_chapter_callback)
      else
        if $("#pushNotificationModal").data().push_notification_operation == "edit"
          fieldset = $("#push_notification_chapter_fields").find("[data-trigger='#{trigger}']")
          index = fieldset.attr('id').split("_").pop()
          fieldset.find("[name='course[push_notifications_chapter_attributes][#{index}][trigger]']").val(trigger)
          fieldset.find("[name^='course[push_notifications_chapter_attributes][#{index}][messages]']").remove()
          messages = {}
          $("textarea[id^='push_notification_chapter_message_']").each ->
            id_parts = $(this).attr('id').split('_')
            message_number = id_parts[id_parts.length - 1]
            language_id = id_parts[id_parts.length - 2]
            messages[language_id] ||= {}
            if !!$(this).val()
              messages[language_id][message_number] = $(this).val();
              field = $("<input type='hidden' name='course[push_notifications_chapter_attributes][#{index}][messages][#{language_id}][#{message_number}]' />");
              field.val($(this).val());
              fieldset.append(field);
          json = {trigger: trigger, messages: messages}
          $("[data-notifiable-index='#{index}']").attr("data-notifiable", JSON.stringify(json))
          $("#pushNotificationModal").closeModal()
        else
          alert("A push notification associated with the selected trigger and language already exists")
    else
      alert(errors.join("\n"))

  $("#pushNotificationModal #story_unlocked_notification_form").find('textarea').keyup ->
    id_parts = $(this).attr('id').split("_")
    message_number = id_parts[id_parts.length - 1]
    language_id = id_parts[id_parts.length - 2]
    character_limit_span_id = "push_notification_message_character_limit_#{language_id}_#{message_number}"
    if $(this).val().length < 65
      $("#pushNotificationModal #story_unlocked_notification_form").find("##{character_limit_span_id}").text("(#{$(this).val().length}/65)")
      $("#pushNotificationModal #story_unlocked_notification_form").find("##{character_limit_span_id}").removeClass("red-text")
    else
      $("#pushNotificationModal #story_unlocked_notification_form").find("##{character_limit_span_id}").text("(65/65)")
      $("#pushNotificationModal #story_unlocked_notification_form").find("##{character_limit_span_id}").addClass("red-text")

  $("#pushNotificationModal #chapter_unlocked_notification_form").find('textarea').keyup ->
    id_parts = $(this).attr('id').split("_")
    message_number = id_parts[id_parts.length - 1]
    language_id = id_parts[id_parts.length - 2]
    character_limit_span_id = "push_notification_chapter_message_character_limit_#{language_id}_#{message_number}"
    if $(this).val().length < 65
      $("#pushNotificationModal #chapter_unlocked_notification_form").find("##{character_limit_span_id}").text("(#{$(this).val().length}/65)")
      $("#pushNotificationModal #chapter_unlocked_notification_form").find("##{character_limit_span_id}").removeClass("red-text")
    else
      $("#pushNotificationModal #chapter_unlocked_notification_form").find("##{character_limit_span_id}").text("(65/65)")
      $("#pushNotificationModal #chapter_unlocked_notification_form").find("##{character_limit_span_id}").addClass("red-text")
